import * as React from 'react'
import { ReactElement } from 'react'
import InvoiceForm from '../../../components/Form/Finance/Invoice/InvoiceForm'
import { InvoiceMutationDto, InvoiceStatus, InvoiceType } from '../../../config/finance/invoiceConfig'
import { formatIsoDate } from '../../../helpers/dateHelper'

export function defaultInvoiceValues(): InvoiceMutationDto {
    return {
        type: InvoiceType.Regular,
        templateId: undefined,
        children: undefined,
        status: InvoiceStatus.New,
        fileIds: [],
        clientPivotId: undefined,
        debtorPivotId: undefined,
        number: undefined,
        name: '',
        description: undefined,
        date: formatIsoDate(new Date()),
        term: 0,
        lineItemGroups: [],
        language: undefined,
        currency: undefined,
        messageSubject: undefined,
        messageBody: undefined,
        unit: undefined, // The initial unit is dependent on the default unit of the file.
    }
}

export default function AddInvoice(props): ReactElement {
    return (
        <InvoiceForm
            formikProps={{
                initialValues: {
                    ...defaultInvoiceValues(),
                    ...(props?.location?.state ? props?.location?.state : {}),
                },
                onSubmit: () => {
                    return Promise.resolve({
                        url: '/finance/invoice',
                        method: 'POST',
                    })
                },
            }}
        />
    )
}
